'use strict';
var template,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

template = require('../vVERSION.html.mustache');

module.exports = (function() {
  return {
    init: function() {
      if (!(this.$el = $('#ls-in-app-messages')).length) {
        return;
      }
      return this.fetch();
    },
    fetch: function() {
      var c, categoryId, data, ref, ref1, ref2, ref3;
      c = (ref = Cookie.get('c')) != null ? ref.replace(/"/g, '') : void 0;
      categoryId = document.head.getAttribute('data-categoryid');
      data = {
        division_id: typeof Groupon !== "undefined" && Groupon !== null ? (ref1 = Groupon.division) != null ? ref1.id : void 0 : void 0,
        page: 1,
        per_page: 1,
        consumer_id: c ? c : void 0,
        app_name: document.head.getAttribute('data-app'),
        locale: document.head.getAttribute('data-locale'),
        category_id: categoryId ? categoryId : void 0
      };
      if ((ref2 = Groupon.PageFlags) != null ? ref2.isTouchRequest : void 0) {
        data.device_id = 'ITIER-DEVICE_ID';
      }
      if (Groupon.LS.experiments['LS-2120-IAM-Viewport-Param']) {
        data.viewport = $(window).width();
      }
      return $.ajax({
        type: "GET",
        url: ((ref3 = Groupon.endpoints) != null ? ref3.in_app_messages : void 0) || '/in_app_messages',
        data: data,
        success: (function(_this) {
          return function(res) {
            var blocked, ref4;
            if ((res != null ? res.id : void 0) != null) {
              blocked = _this.getBlockedMessageIds();
              _this.id = res.id.toString();
              if (ref4 = _this.id, indexOf.call(blocked, ref4) < 0) {
                _this.$el.html(template.render({
                  res: res
                }));
                return _this.attachDismissListener();
              }
            } else {
              return Groupon.Utils.trackEvent('iam-no-message-id');
            }
          };
        })(this),
        error: function() {
          return Groupon.Utils.trackEvent('iam-call-failed');
        }
      });
    },
    getBlockedMessageIds: function() {
      var value;
      value = Cookie.get('msg_hide');
      if (value) {
        return value.split(",");
      } else {
        return [];
      }
    },
    setBlockedMessageIds: function(blocked) {
      var value;
      if (blocked.length > 20) {
        blocked.shift();
      }
      value = blocked.join(",");
      return Cookie.set('msg_hide', value);
    },
    blockMessage: function(message_id) {
      var blocked;
      blocked = this.getBlockedMessageIds();
      if (indexOf.call(blocked, message_id) < 0) {
        blocked.push(message_id);
        return this.setBlockedMessageIds(blocked);
      }
    },
    attachDismissListener: function() {
      var ref, ref1;
      return this.$el.find('.hide-link').attr('aria-label', ((ref = Groupon.LS.translations) != null ? (ref1 = ref.ax) != null ? ref1.close : void 0 : void 0) || 'close').one('click', (function(_this) {
        return function(event) {
          event.preventDefault();
          _this.$el.addClass('hide');
          if (_this.id > 0) {
            return _this.blockMessage(_this.id);
          }
        };
      })(this));
    }
  };
})();

